import { Component, Input } from '@angular/core';
import { SpecialFormControl } from '@utilities/SpecialForms';
import { Observable, Subscription, combineLatest } from 'rxjs';

@Component({
  selector: 'control-belong-diploma',
  templateUrl: './control-belong-diploma.component.html',
  styleUrls: ['./control-belong-diploma.component.scss']
})
export class ControlBelongDiplomaComponent {
  // @Input('readOnly') _readOnly = false;
  @Input('sfcontrol') _sfcontrol: SpecialFormControl;

  value: any = "";
  subs: Subscription = new Subscription();
  data: Object[] = [];
  labelTextButton: string;
  labelSelect: string;
  labelPlaceHolder: string;

  ngOnInit() {
    if (this._sfcontrol.data[0] instanceof Observable) {
      // this.subs.add(
      //   combineLatest(
      //     this._sfcontrol.data[0].pipe(filter(a => a ? true : false)),
      //     this._sfcontrol.valueChanges,
      //     (data: Array<any>, value) => {
      //       const select = data.find(a => a[this._sfcontrol.data[1]] === value);
      //       select && this._sfcontrol.setComplement(select);
      //     }
      //   ).subscribe(() => { })
      // )
      this.subs.add(
        this._sfcontrol.data[0].subscribe(d => {
          this.data = d;
          this.asignacionEtiqueta(this.textProcessor(this._sfcontrol.label));
        })
      )
    } else {
      this.data = this._sfcontrol.data[0];
      // this._sfcontrol.valueChanges.pipe(
      // ).subscribe((value) => {
      //   const select = this.data.find(a => a[this._sfcontrol.data[1]] === value);
      //   select && this._sfcontrol.setComplement(select);
      // })
      this.asignacionEtiqueta(this.textProcessor(this._sfcontrol.label));
    }
  }

  private asignacionEtiqueta( data: string[] ): void {
    this.labelSelect = data[0];
    this.labelPlaceHolder = data[1];
    this.labelTextButton = data[2];
  }

  public textProcessor(input: string): string[] {
    return input.split(',').map(data => data.trim());
  }

  public salidaElemento(element: string): void {
    this._sfcontrol.markAsDirty();
    this._sfcontrol.setValue({element: element, id: null});
  }

  public salidaSelector(id: number): void {
    this._sfcontrol.markAsDirty();
    this._sfcontrol.setValue({element: null, id: id});
  }

  // select(value) {
  //   this._sfcontrol.markAsDirty();
  //   this._sfcontrol.setValue(value);
  // }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
